const breakPoint = 767;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();





// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^='#']").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};



// ------------------------------------------------------------------------
// toggleMenu
// ------------------------------------------------------------------------
const toggleMenu = () => {
  $('.header-hamburger_button,.header-fixed').on('click', function() {
    $(".header-hamburger_button").toggleClass("open");
    $(".header-fixed").toggleClass("open");
  });
  $('.header-fixed_inner').on('click', function(e) {
    e.stopImmediatePropagation();
  });
};



// ------------------------------------------------------------------------
// preload
// ----- BOTH
// ------------------------------------------------------------------------
const preload = () => {
  $(window).on("load", function () {
    $("body").removeClass("preload");
    $(".st-Container").css("opacity", "");
  });
};



// ------------------------------------------------------------------------
// preloadIndex
// ----- BOTH
// ------------------------------------------------------------------------
const preloadIndex = () => {
  $(window).on("load", function () {
    $("body").removeClass("preload");
    idxLoading();
  });
};



// ------------------------------------------------------------------------
// idxLoading
// ----- BOTH
// ------------------------------------------------------------------------
const enableContents = () => {
  $(".idx-Loading").removeClass("open");
  $(".idx-Loading").addClass("close");
  $(".st-Container").css("opacity", "");
  $(".js-ld").toggleClass("animated");
  lscache.set('loading', {'trg': 1}, 1440);
}

const idxLoading = () => {
  let flag = lscache.get('loading');
  let trg = flag ? flag.trg : 0;
  console.log(trg);
  if(trg == 1) {
    enableContents();
  } else {
    $(".idx-Loading").addClass("open");
    setTimeout(function () {
      enableContents();
    }, 3000);
  }
};



// ------------------------------------------------------------------------
// animScroll
// ------------------------------------------------------------------------
const animScroll = () => {
  $(window).on("load", function () {
    let margin = 0;
    if (matchMedia('(max-width: 768px)').matches) {
      margin = 150;
    } else {
      margin = 300;
    }
    $(".js-sc").each(function (i, node) {
      gsap.to(node, {
        scrollTrigger: {
          trigger: node,
          start: 'top bottom-=' + margin,
          toggleClass: { targets: node, className: "animated" },
          once: true,
        }
      });
    });
  });
};



// ------------------------------------------------------------------------
// animLoad
// ------------------------------------------------------------------------
const animLoad = () => {
  $(window).on("load", function () {
    $(".js-ld").toggleClass("animated");
  });
};



export {
  anchorLink,
  toggleMenu,
  preload,
  preloadIndex,
  animScroll,
  animLoad
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js